import { useEffect, useRef } from "react";
import { tracking } from "../../services/tracking";
import { trackCheckoutStarted } from "../../services/tracking/payments/checkoutStepsEvents";

// O plano é reconciliado num effect depois do catálogo carregar; sem essa folga o
// evento sairia no mesmo render em que o catálogo assenta, ainda com plan null.
export const CHECKOUT_STARTED_PLAN_GRACE_MS = 500;

/**
 * Dispara `checkout_started` uma vez por montagem, já com `plan_name`.
 * Dispara quando o plano existe; se o catálogo assentou (carregou ou falhou) e
 * nenhum plano apareceu, dispara mesmo assim para não sumir do topo do funil.
 */
export function useTrackCheckoutStarted({ formValues, isCatalogSettled }) {
  const trackedRef = useRef(false);
  const formValuesRef = useRef(formValues);
  formValuesRef.current = formValues;

  const hasPlan = Boolean(formValues?.plan?.name);

  useEffect(() => {
    if (trackedRef.current) return undefined;

    const fire = () => {
      trackedRef.current = true;
      trackCheckoutStarted(
        tracking.checkout.prepareCheckoutStartedForAnalytics(
          formValuesRef.current,
          {}
        )
      );
    };

    if (hasPlan) {
      fire();
      return undefined;
    }
    if (!isCatalogSettled) return undefined;

    const timer = setTimeout(fire, CHECKOUT_STARTED_PLAN_GRACE_MS);
    return () => clearTimeout(timer);
  }, [hasPlan, isCatalogSettled]);
}
